<template>
    <div class="card">
        <div class="card-header bg-white">
            <div class="row align-items-center">
                <div class="col px-0">
                    <h5 class="me-auto">Manejo</h5>
                </div>
                <div class="col-auto">
                    <div class="hstack gap-2 justify-content-end">
                        <button type="button" class="btn btn-h btn-dark" @click="ADD_TEXT('[$taxed]')">
                            <span>Impuesto</span>
                        </button>
                        <button @click="ADD()" type="button" class="btn btn-h btn-primary">
                            <span><i class="bi bi-plus"></i></span>
                        </button>
                        <button @click="SAVE()" type="button" class="btn btn-h btn-success px-3">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body border-bottom px-0">
            <div class="row">
                <div class="col-lg-2 d-flex mb-2">
                    <button type="button" class="btn btn-h btn-dark" @click="ADD_TEXT('[$handling]')">
                        <span>Manejo</span>
                    </button>
                    <span class="ml-auto mr-2"> = </span>
                </div>
                <div class="col-lg-1 px-lg-1 mb-2">
                    <input class="form-control form-control-sm" v-model="data.min"
                    @focus="SET_INPUT('min')"
                    @input="GET_INPUT" 
                    @keypress="DOUBLE_OPERATOR">
                </div>
                <div class="col-lg-1 px-lg-1 mb-2">
                    <v-select
                        :items="mats"
                        v-model="data.mat"
                        hide-details
                        class="form-control form-control-sm">
                    </v-select>
                </div>
                <div class="col-lg-1 px-lg-1 mb-2">
                    <input type="text" v-model="data.max" class="form-control form-control-sm" 
                    @focus="SET_INPUT('max')"
                    @input="GET_INPUT" 
                    @keypress="DOUBLE_OPERATOR">
                </div>
            </div>
        </div>
        <div class="card-body px-0 py-2">
            <v-data-table  class="elevation-1 no-hover"
                :items="data.switch.slice().reverse()"
                hide-default-header
                hide-default-footer>
                <template v-slot:[`item`]="{ item, index }">
                    <tr colspan="100%">
                        <div class="container-fluid py-3" :class="index != 0 ? 'border-top' : ''">
                            <app-switch :data="item" :id="index+1" :add_text="add_text" :btn="btn" :set_id="set_id" @set_id="e => set_id = e" @remove="REMOVE"/>
                        </div>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            data: {
                min: '',
                mat: '',
                max: '',
                switch: []
            },
            count: 0,
            btn: '',
            add_text: 0,
            set_id: '',
            input: '',
            operators: [
                '',
                '==',
                '>',
                '<',
                '>=',
                '<=',
            ],
            conditions: [
                '',
                '&&',
                '||',
            ],
            mats: [
                '',
                '+',
                '-',
                '*',
                '/',
            ],
            set_value: '',
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/calculator/handling', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        ADD_TEXT: function(btn){
            let vue = this
            if(vue.set_id == ''){
                if(vue.data[vue.input] != btn){
                    vue.data[vue.input] = btn
                    vue.btn = btn
                }
            }else{
                vue.add_text++
                vue.btn = btn
            }
        },
        SET_INPUT: function(input){
            let vue = this
            vue.set_id = ''
            vue.input = input
            vue.set_value = vue.data[vue.input]
        },
        GET_INPUT: function(){
            let vue = this
            if(vue.set_id == ''){
                if(vue.set_value == vue.btn){
                    vue.data[vue.input] = ''
                    vue.set_value = ''
                }
            }
        },
        ADD: function(){
            let vue = this
            let value = vue.data.switch.findIndex(e => e.type == 'D')
            let type = 'D'
            if(value >= 0){
                type = 'C'
            }
            vue.data.switch.push(
                {
                    id: vue.data.switch.length+1,
                    type: type,
                    values: [
                        {
                            min: '',
                            operator: '',
                            max: '',
                            condition: '',
                            disabled: false
                        },
                    ],
                    return: {
                        min: '',
                        mat: '',
                        max: '',
                    }
                },
            )
        },
        REMOVE: function(id){
            let vue = this
            let index = vue.data.switch.findIndex(e => e.id == id)
            if(index != -1){
                vue.data.switch.splice(index, 1)
            }
        },
        SAVE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/calculator/handling', method: 'POST', data: { handling: vue.data } })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>